<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi" id="ch00_fm05_deti"><a id="page_v"></a><em>For Barbara Davis</em><br/><br/><em>and for Julius and Margery McIntosh</em>,<br/><br/><em>who have invested so much</em><br/><br/><em>in art and people</em><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm05_deti.vue?60a93eef